import type { ApiClient } from './runtime/apiRuntime';
import { apiMutationOptions, BaseApiMutationOptions } from './apiMutationOptions';
import { apiQueryOptions, BaseApiQueryOptions } from './apiQueryOptions';

export const LiveTranscribeApi = {
    getDeepgramSettings: (webinarId: string, options?: BaseApiQueryOptions) =>
        apiQueryOptions(['liveTranscribe', 'getDeepgramSettings', webinarId], (api) => api.liveTranscribe.getDeepgramSettings(webinarId), options),
    setDeepgramSettings: (options?: BaseApiMutationOptions<ApiClient['liveTranscribe']['setDeepgramSettings']>) =>
        apiMutationOptions((api) => api.liveTranscribe.setDeepgramSettings, options)
};
